import { render, staticRenderFns } from "./inputSelect.vue?vue&type=template&id=1c24a57a&"
import script from "./inputSelect.vue?vue&type=script&lang=js&"
export * from "./inputSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports